import { useLayoutEffect, type ReactNode } from 'react';
import { useUiStore } from '@noor/lib';

/**
 * Applies the persisted theme to <html class="dark"> and keeps it in sync.
 * Theme is ephemeral UI state owned by the Zustand store (durable via persist).
 *
 * A LAYOUT effect (not a passive one) for two reasons: the class flips before
 * paint (no one-frame flash of the wrong theme), and the header's theme toggle
 * runs the switch inside `document.startViewTransition(() => flushSync(...))`
 * — layout effects run synchronously within that flush, so the transition's
 * "new" snapshot is guaranteed to capture the re-themed page.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useUiStore((s) => s.theme);

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return children;
}
